export const TitleCaseFilterModule = angular
    .module('app.filters.titleCaseFilter', [])
    .filter('titleCase', () => {
        return (s) => {
            s = (s === undefined || s === null) ? '' : s;
            return s.toString().replace(/(\b([a-z])|[A-Z])/g, (ch) => {
                return ` ${ch.toUpperCase()}`;
            }).trim();
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/titleCase.filter.js